var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { device } from '../../breakpoints';
import { maskEmail } from '../../utils';
import { Icon } from '../../../Icon';
import { Text } from '../../../Text';
import { colors, getFontSize } from '../../../../abstracts';
var ProfileDetailsContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 58px;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n\n  object {\n    width: 42px;\n    @media ", " {\n      width: 58px;\n    }\n  }\n"], ["\n  height: 58px;\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n\n  object {\n    width: 42px;\n    @media ", " {\n      width: 58px;\n    }\n  }\n"])), device.laptop);
var EmailContainer = styled(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 11px;\n  font-size: ", ";\n  color: ", ";\n\n  @media ", " {\n    margin-left: 20px;\n    font-size: ", ";\n  }\n"], ["\n  margin-left: 11px;\n  font-size: ", ";\n  color: ", ";\n\n  @media ", " {\n    margin-left: 20px;\n    font-size: ", ";\n  }\n"])), getFontSize(1), colors.neutralDeepest, device.laptop, getFontSize(2));
export var ProfileDetails = function (_a) {
    var email = _a.email;
    return (React.createElement(ProfileDetailsContainer, null,
        React.createElement(Icon, { src: "RoundedUser", size: "large" }),
        React.createElement(EmailContainer, null, maskEmail(email))));
};
var templateObject_1, templateObject_2;
